import request from '@/utils/request'
import Vue from 'vue'

export function login (username, password, customerId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/auth/login',
    method: 'post',
    data: {
      customerId: customerId,
      login: username,
      password: password
    }
  })
}

export function wxlogin (code, appsecret) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/auth/wxlogin',
    method: 'post',
    data: {
      code: code
    }
  })
}

// 刷新token
export function refreshToken (login, name) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/auth/refreshToken`,
    method: 'get',
    params: {
      login: login,
      name: name
    }
  })
}

export function modifyPasswd (modifyForm) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/user',
    method: 'patch',
    data: {
      login: modifyForm.name,
      oldpassword: modifyForm.old_passwd,
      newpassword: modifyForm.cfm_password
    }
  })
}

export function getStation (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/all/${data.user}/${data.skip}/${data.take}`,
    method: 'get',
    params: {
      name: data.station
    }
  })
}

export function getUser (login) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/${login}`,
    method: 'get'
  })
}

export function updateUser (login, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/${login}`,
    method: 'patch',
    data: {
      name: data.nickName,
      mobile: data.mobile,
      birthday: data.birthday,
      position: data.position,
      company: data.company
    }
  })
}

export function unbundling (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/user/wx/unbundling',
    method: 'patch',
    data: {
      login: data.login,
      openId: data.openId,
      bindType: data.bindType
    }
  })
}

// 微信绑定
export function wxbind (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/user/wx/wxbind',
    method: 'patch',
    data: {
      login: data.login,
      code: data.code
    }
  })
}

// 刷新头像
export function refresHead (userid) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/refreshhead/${userid}`,
    method: 'post'
  })
}

// 查询片区
export function getRegions (customerId, withStation) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/regions/${customerId}/${withStation}`,
    method: 'get'
  })
}

// 新增片区
export function addRegions (customerId, name, parentId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/regions/${customerId}`,
    method: 'post',
    data: {
      name: name,
      parentId: parentId
    }
  })
}

// 修改片区
export function updateRegions (customerId, id, name, parentId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/regions/${customerId}/${id}`,
    method: 'patch',
    data: {
      name: name,
      parentId: parentId
    }
  })
}

// 删除片区
export function deleteRegions (customerId, id) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/regions/${customerId}/${id}`,
    method: 'delete'
  })
}

export function getStationByRegion (customerId, regionId, name, skip, take) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/get-by-region/${customerId}/${regionId}/${skip}/${take}`,
    method: 'get',
    params: {
      name: name
    }
  })
}

export function getStationById (customerId, id) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/${customerId}/${id}`,
    method: 'get'
  })
}

export function addStation (customerId, name, url, isActive, jwtSecret, regionId, latitude, longitude, siteId, property1, property2, property3) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/${customerId}`,
    method: 'post',
    data: {
      name: name,
      url: url,
      isActive: isActive,
      jwtSecret: jwtSecret,
      parentId: regionId,
      latitude: latitude,
      longitude: longitude,
      siteId: siteId,
      property1: property1,
      property2: property2,
      property3: property3
    }
  })
}

export function editStation (customerId, id, name, url, isActive, jwtSecret, regionId, latitude, longitude, siteId, property1, property2, property3) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/${customerId}/${id}`,
    method: 'patch',
    data: {
      name: name,
      url: url,
      isActive: isActive,
      jwtSecret: jwtSecret,
      parentId: regionId,
      latitude: latitude,
      longitude: longitude,
      siteId: siteId,
      property1: property1,
      property2: property2,
      property3: property3
    }
  })
}

// 删除油站
export function deleteStation (customerId, id) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/gas-station/${customerId}/${id}`,
    method: 'delete'
  })
}

export function getUserByCustomer (customerId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/${customerId}`,
    method: 'get'
  })
}

// 添加用户
export function addUser (name, login, password, isActive, userType, customerId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user`,
    method: 'post',
    data: {
      name: name,
      login: login,
      password: password,
      isActive: isActive,
      userType: userType,
      customerId: customerId
    }
  })
}

// 重置密码
export function resetPwd (userid) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/resetPwd/${userid}`,
    method: 'post'
  })
}

// 删除用户
export function deleteUser (userid) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/${userid}`,
    method: 'delete'
  })
}

// 更新用户选中的油站
export function updateGasStationInUser (userid, gasStations) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/update-gasstations/${userid}`,
    method: 'post',
    data: {
      gasStations: gasStations
    }
  })
}

// 管理员更新用户
export function updateUserByAdmin (userid, login, name, userType, isActive) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/adminUpdateUser/${userid}`,
    method: 'patch',
    data: {
      login: login,
      name: name,
      userType: userType,
      isActive: isActive
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js